import axiosInstance from './axios';
import { encryptData } from '../utils/encryption';

export const secretService = {
  getAllSecrets: () => 
    axiosInstance.get('/api/secrets'),

  getCategories: () =>
    axiosInstance.get('/api/secrets/categories'),

  addSecret: async (secretData, key) => {
    const encryptedData = encryptData(secretData.data, key);
    const payload = {
      type: secretData.type,
      category: secretData.category,
      title: secretData.title,
      encryptedData
    };
    return await axiosInstance.post('/api/secrets', payload);
  },

  deleteSecret: (id) =>
    axiosInstance.delete(`/api/secrets/${id}`),

  updateSecret: (id, secretData) =>
    axiosInstance.put(`/api/secrets/${id}`, secretData),
};

export default secretService;
